module.exports = __webpack_public_path__ + "static/media/4.ba0204aa.png";